// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"afd90057","787":"51358596"}[chunkId] + ".chunk.js";
};